import React, { useEffect, useState, useMemo } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import './ProjectDetails.css';
import Loader from '../../Loader/Loader';

const ProjectDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [projects, setProjects] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProjectData = async () => {
            try {
                const response = await fetch('/projects/projects.json');
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setProjects(data);
            } catch (error) {
                console.error('Failed to fetch project data:', error);
                setError('Failed to load project data');
            }
        };

        fetchProjectData();
    }, []);
    
    useEffect(() => {
        scroll.scrollToTop(); // Scroll to the top of the page
    }, []);

    // Memoize the selected project data
    const project = useMemo(() => {
        if (projects && id) {
            return projects[id] || null;
        }
        return null;
    }, [projects, id]);

    if (error) {
        return <div>{error}</div>;
    }

    if (!projects) {
        return <Loader />;
    }

    if (!project) {
        return <div>Project not found</div>;
    }

    const { title, description, imgSrc, githubLink, webpageLink, skills, button } = project;

    return (
        <Container fluid className='project-details-container'>
            <Button onClick={() => navigate(-1)} className='back-button' variant='secondary'>
                &lt; Back
            </Button>
            <Row className='align-items-center'>
                <Col md={6} className='text-center mb-4 mb-md-0'>
                    <img src={imgSrc} alt={title} className='project-image' />
                </Col>
                <Col md={6}>
                    <h1 className='project-title'>{title}</h1>
                    <div
                        className='project-description'
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                    <div className='project-links'>
                        {githubLink && (
                            <Button href={githubLink} target='_blank' className='project-link' variant='primary'>
                                GitHub
                            </Button>
                        )}
                        {webpageLink && (
                            <Button href={webpageLink} target='_blank' className='project-link' variant='secondary'>
                                {button}
                            </Button>
                        )}
                    </div>
                    <div className='skills-list'>
                        <h3>Skills Used:</h3>
                        <ul>
                            {skills.map((skill, index) => (
                                <li key={index} className='skill-item'>{skill}</li>
                            ))}
                        </ul>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default ProjectDetails;
